































import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import CreateNewProperty from '../../../../../../../../../../../BotProperties/components/Properties/CreateNewProperty.vue'
import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon } from '../../../../../../../../../../../BotProperties/utils'
import { UseFields } from '../../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../../Pi/types'
import PropertyValue from '../../../../../logic/PropertyConditionValues/PropertyValue'
import { ConditionsNodeProps } from '../../../../../logic/types'

const STRING = [
  PropertyFieldType.String,
  PropertyFieldType.Email,
  PropertyFieldType.Phone,
  PropertyFieldType.DateTime,
  PropertyFieldType.Date,
  PropertyFieldType.Time,
]

const NUMBER = [
  PropertyFieldType.Number,
  PropertyFieldType.Double,
]

const DATE_TIME = [
  PropertyFieldType.DateTime,
  PropertyFieldType.Date,
  PropertyFieldType.Time,
]

@Component({
  components: {
    CreateNewProperty
  }
})
export default class PropertyConditionValueSettings extends Mixins(UseFields) {
  @VModel() conditionValue!: PropertyValue

  @Prop() selectedProperty!: GroupedBotProperty

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() createProperty!: ConditionsNodeProps['createNewProperty']

  newPropertyName = ''

  isOpen = false

  get context(): this {
    return this
  }

  get ignoreRegister(): boolean {
    return this.conditionValue.transform
  }

  get propertyOptions(): Array<SelectOptionData> {
    return this.compatibleProperties.map((p) => {
      return {
        label: p.name ?? p.type,
        value: p.id,
        icon: {
          iconPack: 'material-icons',
          name: getNewPropertyIcon(p.path ?? p.type)
        }
      }
    })
  }

  get compatibleProperties(): Array<GroupedBotProperty> {
    const { type, id } = this.selectedProperty

    switch (type) {
      case PropertyFieldType.String:
      case PropertyFieldType.Email:
      case PropertyFieldType.Phone:
        return this.properties.filter((p) => STRING.includes(p.type) && p.id !== id)
      case PropertyFieldType.Number:
      case PropertyFieldType.Double:
        return this.properties.filter((p) => NUMBER.includes(p.type) && p.id !== id)
      case PropertyFieldType.DateTime:
        return this.properties.filter((p) => DATE_TIME.includes(p.type) && p.id !== id)
      case PropertyFieldType.Time:
        return this.properties.filter((p) => [ PropertyFieldType.DateTime, PropertyFieldType.Time ].includes(p.type) && p.id !== id)
      case PropertyFieldType.Date:
        return this.properties.filter((p) => [ PropertyFieldType.DateTime, PropertyFieldType.Date ].includes(p.type) && p.id !== id)
      case PropertyFieldType.Flag:
        return this.properties.filter((p) => p.type === PropertyFieldType.Flag && p.id !== id)
      case PropertyFieldType.Files:
        return this.properties.filter((p) => p.type === PropertyFieldType.Files && p.id !== id)
      default:
        return []
    }
  }

  createNewPropertyHandler({ label }: SelectOptionData): void {
    this.newPropertyName = label
    this.isOpen = true
  }

  setProperty(arg: FieldData): FieldData {
    arg.setter = (val) => this.conditionValue.property_index = val
    return arg
  }
}
